<life-di-nav></life-di-nav>
<!-- develop feture register -->
<div class="container-fulid text-center overflow-hidden" style="padding-top: 50px;">
  <div class="row justify-content-center">
    <div class="col-8">
      <h1>
        สร้างบัญชี
      </h1>
      <form [formGroup]="registerForm">
        <div class="form-group row">
          <label for="username" class="col-md-3 col-form-label text-md-right">Username<lifedi-require></lifedi-require>
            </label>
          <div class="col-md-6">
            <input type="text" class="form-control" id="username" formControlName="username">
          </div>
        </div>
        <div class="form-group row">
          <label for="email" class="col-md-3 col-form-label text-md-right">Email<lifedi-require></lifedi-require>
            </label>
          <div class="col-md-6">
            <input type="email" class="form-control" id="email" formControlName="email">
          </div>
        </div>
        <div class="form-group row">
          <label for="gender" class="col-md-3 col-form-label text-md-right">เพศ<lifedi-require></lifedi-require></label>
          <div class="col-md-6">
            <select class="custom-select" id="gender" formControlName="gender">
              <option value="ชาย">ชาย</option>
              <option value="หญิง">หญิง</option>
              <option value="ไม่ระบุ">ไม่ระบุ</option>
            </select>
          </div>
        </div>
        <div class="form-group row">
          <label for="dateOfBirth" class="col-md-3 col-form-label text-md-right">วัน/เดือน/ปีเกิด<lifedi-require>
            </lifedi-require></label>
          <div class="col-md-6">
            <input type="text" class="form-control" id="dateOfBirth" formControlName="dateOfBirth" bsDatepicker
              [(bsValue)]="registerForm.value.dateOfBirth"
              value="{{ registerForm.value.dateOfBirth | date:'DD/MM/YYYY' }}"
              [bsConfig]="{ containerClass: 'theme-red', showWeekNumbers: false }">
          </div>
        </div>
        <div class="form-group row">
          <label for="password" class="col-md-3 col-form-label text-md-right">รหัสผ่าน<lifedi-require></lifedi-require>
            </label>
          <div class="col-md-6">
            <input [type]="passwordType ? 'text' : 'password'" class="form-control" id="password"
              formControlName="password">
            <span toggle="#passwordLogin" class="toggle-password">
              <a>
                <img src="../../../assets/dark-visibility.png" id="toggle-eye" alt="visibility"
                  (click)="passwordTypeToggle()">
              </a>
            </span>
          </div>
        </div>
        <div class="form-group row">
          <label for="confirmEmail" class="col-md-3 col-form-label text-md-right">ยืนยันรหัสผ่าน<lifedi-require>
            </lifedi-require></label>
          <div class="col-md-6">
            <input [type]="confirmPasswordType ? 'text' : 'password'" class="form-control" id="confirmEmail"
              formControlName="confirmPassword">
            <span toggle="#passwordLogin" class="toggle-password">
              <a>
                <img src="../../../assets/dark-visibility.png" id="toggle-eye" alt="visibility"
                  (click)="confirmPasswordTypeToggle()">
              </a>
            </span>
          </div>
        </div>
        <span class="text-danger" style="margin-top: 10px;">{{errMsg}}</span>
        <div class="row justify-content-center">
          <div class="col-md-6">
            <lifedi-btn lable="สร้างบัญชี" *ngIf="!registerForm.valid" [disabled]="!registerForm.valid"
              customStyle="width: 100%;">
            </lifedi-btn>
            <lifedi-btn lable="สร้างบัญชี" *ngIf="registerForm.valid" (click)="createAccount()"
              customStyle="color:white; background-color: #414A6B; width: 100%;">
            </lifedi-btn>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
